/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Disable_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to disable SCIM? Your identity provider will no longer be able to manage user accounts. Existing SCIM-provisioned users will remain but..." |
*
* @param {Scim_Disable_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_disable_confirm_description = /** @type {((inputs?: Scim_Disable_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Disable_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sind Sie sicher, dass Sie SCIM deaktivieren möchten? Ihr Identitätsanbieter kann dann keine Benutzerkonten mehr verwalten. Bestehende SCIM-bereitgestellte Benutzer bleiben erhalten, werden aber nicht mehr aktualisiert.")
	return /** @type {LocalizedString} */ ("Are you sure you want to disable SCIM? Your identity provider will no longer be able to manage user accounts. Existing SCIM-provisioned users will remain but won't be updated.")
});